/**
 * Formata uma data "sem hora" (ex.: `due_date`, coluna `date` no backend,
 * que chega como 'YYYY-MM-DD') em dd/mm/aaaa.
 *
 * `new Date('2026-11-10')` é meia-noite UTC; no fuso do Brasil (UTC-3) isso
 * ainda é dia 09, e `toLocaleDateString` mostrava o vencimento um dia antes.
 * Usa as partes UTC, como a coluna Data da aba de conciliação já fazia.
 */
export const formatDateOnly = (s: string | null | undefined) => {
  if (!s) return '-'
  const d = new Date(s)
  if (isNaN(d.getTime())) return '-'
  return new Date(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate()
  ).toLocaleDateString('pt-BR')
}
